import React, { useState, useEffect, useRef, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Grid, CircularProgress, TableRow, TableCell } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
import DateFnsUtils from '@date-io/date-fns';
// components
import PageTitle from "../../components/PageTitle";

import useStyles from './styles';
import config from '../../config';

const Assets = forwardRef((props, ref) => {
  // global
  const classes = useStyles();
  const history = useHistory();

  // local
  var [customerId, setCustomerId] = useState(props.id);
  var [data, setData] = useState(undefined);
  var [page, setPage] = useState(0);
  var [key, setKey] = useState(undefined);
  var [count, setCount] = useState(0);
  var [selectedTypes, setSelectedTypes] = useState([]);
  var [selectedSites, setSelectedSites] = useState([]);
  var [selectedPassed, setSelectedPassed] = useState([]);
  var [selectedDisposed, setSelectedDisposed] = useState([]);
  var [selectedExpiry, setSelectedExpiry] = useState([]);
  var [sortByColumn, setSortByColumn] = useState('');
  var [sortDirection, setSortDirection] = useState('');

  var [offset, setOffset] = useState(0);
  var [rowsPerPage, setRowsPerPage] = useState(50);
  var [isLoading, setIsLoading] = useState(false);
  var [siteNames, setSiteNames] = useState([]);
  var [sites, setSites] = useState([])

  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 2000)).current;
  var [from, setFrom] = useState();
  var [to, setTo] = useState();
  const [isTimeRangeInvalid, setIsTimeRangeInvalid] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


  const columns = [
    { label: 'ID', name: 'id', options: {filter: false, display: false}},
    { label: 'CODE', name: 'code', options: {filter: false}},
    { label: 'EXPIRY', name: 'expires',
      options: {
          filter: true,
          customBodyRender: (value) => {
            return value;
          },
          filterType: 'custom',
          customFilterListOptions: {
            render: v => {
              if(v !== null && v !== undefined) {
                return `Expires in: ${v}`
              }

              return false;
            }
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <div className="retest_range_filter">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        views={["year", "month"]}
                        openTo="month"
                        variant="inline"
                        label="Expired in"
                        value={filterList[index][0] || null}
                        error={isTimeRangeInvalid}
                        onChange={date => {
                          filterList[index] = [months[date.getMonth()] + ' ' + date.getFullYear()];
                          onChange(filterList[index], index, column);
                          setupFromAndToForFilter(filterList[index][0]);
                        }}
                        onError={console.log}
                        format="MMM yyyy"
                      />
                  </MuiPickersUtilsProvider>
              </div>
            ),
          },
    }},
    { label: 'TYPE-DESCRIPTION', name: 'description', options: {filter: false}},
    { label: 'MAKE-MODEL', name: 'make', options: {filter: false}},
    { label: 'MODEL', name: 'model', options: {filter: false, display: false}},
    { label: 'ASSET TYPE', name: 'asset_type',
      options: {
            display: false,
            filterOptions: {
                    names: ['ELEC', 'NON-ELEC', 'FIRST_AID', 'FIRE', 'MEDS', 'AED', 'EVSE'],
            },
            customFilterListOptions: {
                      render: v => {
                        return `TYPE: ${v}`;
                      },
            }
      }
    },
    { label: 'CUSTOMER', name: 'customer_name', options: {filter: false} },
    { label: 'SITE', name: 'site_name', options: {filter: false} },
    { label: 'PASSED', name: 'passed',
       options: {
            filter: true,
            filterOptions: {names:['YES','NO']},
            customFilterListOptions: {
              render: v => {
                return `PASSED: ${v}`;
                },
            },
    }},
    { label: 'DISPOSED', name: 'disposed',
      options: {
            display: false,
            filterOptions: {names:['YES','NO']},
            customFilterListOptions: {
                          render: v => {
                            return `DISPOSED: ${v}`;
                          },
            }}}
  ];

  const customerColumns = [
    { label: 'ID', name: 'id', options: {filter: false, display: false}},
    { label: 'CODE', name: 'code', options: {filter: false}},
    { label: 'EXPIRY', name: 'expires',
      options: {
          filter: true,
          customBodyRender: (value) => {
            return value;
          },
          filterType: 'custom',
          customFilterListOptions: {
            render: v => {
              if(v !== null && v !== undefined) {
                return `Expires in: ${v}`
              }

              return false;
            }
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <div className="retest_range_filter">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        views={["year", "month"]}
                        openTo="month"
                        variant="inline"
                        label="Expired in"
                        value={filterList[index][0] || null}
                        error={isTimeRangeInvalid}
                        onChange={date => {
                          filterList[index] = [months[date.getMonth()] + ' ' + date.getFullYear()];
                          onChange(filterList[index], index, column);
                          setupFromAndToForFilter(filterList[index][0]);
                        }}
                        onError={console.log}
                        format="MMM yyyy"
                      />
                  </MuiPickersUtilsProvider>
              </div>
            ),
          },
    }},
    { label: 'TYPE-DESCRIPTION', name: 'description', options: {filter: false}},
    { label: 'MAKE-MODEL', name: 'make', options: {filter: false}},
    { label: 'MODEL', name: 'model', options: {filter: false, display: false}},
    { label: 'ASSET TYPE', name: 'asset_type',
      options: {
            display: false,
            filterOptions: {
                    names: ['ELEC', 'NON-ELEC', 'FIRST_AID', 'FIRE', 'MEDS', 'AED', 'EVSE'],
            },
            customFilterListOptions: {
                      render: v => {
                        return `TYPE: ${v}`;
                      },
            }
      }
    },
    { label: 'SITE', name: 'site_name',
      options: {
            filterOptions: {names: siteNames},
            customFilterListOptions: {
                      render: v => {
                        return `SITE: ${v}`;
                      },
            }} },
            { label: 'PASSED', name: 'passed',
               options: {
                    filter: true,
                    filterOptions: ['YES','NO'],
                    customFilterListOptions: {
                      render: v => {
                        return `PASSED: ${v}`;
                        },
                    },
            }},
            { label: 'DISPOSED', name: 'disposed',
              options: {
                    display: false,
                    filterOptions: {names:['YES','NO']},
                    customFilterListOptions: {
                                  render: v => {
                                    return `DISPOSED: ${v}`;
                                  },
                    }}}
  ];

  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '16px 16px',
           },
       },
     }
   });

    useEffect(() => {
       let mounted = true;

       const fetchData = async() => {
            setIsLoading(true)
            setData([]);
            var fromDate = null;
            var toDate = null;

            if (from !== undefined && from !== null && !isNaN(from.getTime())) {
                var [date, month, year] = from.toLocaleDateString('en-NZ').split("/");
                fromDate = `${year}-${month}-${date}`;

                var newToDate = new Date(from.getFullYear(), from.getMonth() + 1, 0);
                 [date, month, year] = newToDate.toLocaleDateString('en-NZ').split("/");
                 toDate = `${year}-${month}-${date}`;
            }

            if (key !== undefined && key !== null && key !== '' && key.length >= 3) {
                setData([]);
                setPage(0);
                setOffset(0);
              }

            const response = await ttAPI.getAssets(customerId, key, offset, rowsPerPage, selectedTypes, selectedSites, selectedPassed, selectedDisposed, fromDate, toDate, sortByColumn, sortDirection);
            if (response !== null) {
                if(mounted){
                      setIsLoading(false);
                      setData(response.assets === null || response.assets === undefined ? [] : response.assets);
                      setCount(response.total_assets);
                  }
            }

       };

       const fetchSites = async() => {//console.log('isLoadingFromLocationState true')
           setIsLoading(true)
           const siteResponse = await ttAPI.getCustomerSites(customerId);
           if(mounted){
               if (siteResponse !== null && siteResponse !== undefined) {
                   setSites(siteResponse);
                   setSiteNames(siteResponse.map(function (site) {
                                      return site.name
                   }));

                   fetchData();

               }

           }

         }

       //if ((data === null || data === undefined || data.length === 0)) {
           if (isAllAssetsListWithAnySearchingCriteria()) {//console.log('fetching data',customerId, key, selectedTypes, selectedSites, selectedPassed, selectedDisposed, from, to, sortByColumn, sortDirection, rowsPerPage);
              fetchData();
           }
           else if (customerId !== undefined && customerId !== null && customerId > 0) {
              fetchSites();
           }
           else {
              //console.log('clear?');
              setData(undefined);
           }
       //}

       return () => mounted = false;

    }, [customerId, key, selectedTypes, selectedSites, selectedPassed, selectedDisposed, from, to, sortByColumn, sortDirection, rowsPerPage]);

    async function changePage(p, rpp) {
      setPage(p);
      setOffset(p * rpp);
      setData([]);
      setIsLoading(true);
      const response = await ttAPI.getAssets(props.id, key, offset, rpp, selectedTypes, selectedSites, selectedPassed, selectedDisposed, sortByColumn, sortDirection);
      if (response !== null) {
          setData(response.assets);
          setCount(response.total_assets);
          setIsLoading(false);
      }
    };

    async function onSearchKey(key) {
      setKey(key);
    };

    function setupFromAndToForFilter(filter) {
        var fromDate;
        var toDate;

        if (filter !== undefined && filter !== null) {
            fromDate = new Date(filter);
            fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
            toDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0);
          }

          setFrom(fromDate);
          setTo(toDate);
          //console.log('setupFromAndToForFilter',fromDate, toDate);
   }

   function updateFilterOnTableInitOrChange(tableState) {//console.log('updateFilterOnTableInitOrChange',tableState,selectedSites, selectedExpiry)
       if (selectedSites !== undefined && selectedSites !== null/* && selectedSites.length > 0*/) {
             var filteredSites = sites.filter(site => selectedSites.find(id => id === site.id))
                                                   .map(function(site) {
                                                         return site.name;
                                                       });
              tableState.filterList[7] = filteredSites;
              //console.log('setup sites filter', tableState.filterList[7]);
         }
         else {
              //tableState.filterList[7] = [];
         }

         if (selectedExpiry !== undefined && selectedExpiry !== null /*&& selectedExpiry.length > 0*/) {
               tableState.filterList[2] = selectedExpiry;
               //console.log('setup expiry filter', tableState.filterList[2]);
         }
         else {
               //tableState.filterList[2] = [];
         }

         if (selectedPassed !== undefined && selectedPassed !== null /*&& selectedPassed.length > 0*/) {
               if (customerId !== undefined && customerId !== null && customerId > 0) {
                  tableState.filterList[8] = selectedPassed;
               }
               else {
                 tableState.filterList[9] = selectedPassed;
               }

               //console.log('setup passed filter', tableState.filterList[8]);
         }
         else {
               //tableState.filterList[8] = [];
         }
   }

   /*function formatDate(date, format) {console.log('test date',format,date.getMonth(), date.getFullYear());
       const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
       const map = {
               mm: date.getMonth() + 1,
               MMM: monthNames[date.getMonth()],
               dd: date.getDate(),
               yy: date.getFullYear().toString().slice(-2),
               yyyy: date.getFullYear()
       }

       return format.replace(/.mm|MMM|dd|yyyy|yy/gi, matched => map[matched])
  }*/

  function onRowClick(data,index) {
      if (customerId === undefined || customerId === null || customerId <= 0) {
        history.push({pathname:`/app/asset/edit/${data[0]}`,
                                 state:{assetId: data[0]}
                               });
      }
      else {
        window.open(
                `${config.adminApi}/#/app/asset/edit/${data[0]}`,
                '_blank'
              );
      }
  }

  function isAllAssetsListWithAnySearchingCriteria() {
    if (customerId === undefined || customerId === null || customerId <= 0){
      if ((key !== undefined && key !== null && key.length >= 3) ||
           selectedTypes.length > 0 || selectedPassed.length > 0 ||
          (from !== undefined && from !== null && from != '' && from != 'Invalid Date' &&
           to !== undefined && to !== null && to != '' && to != 'Invalid Date')){
           return true;
      }

    }
    return false;
  }

  return (
    <>
      {(customerId === null || customerId === undefined || customerId <= 0) && <PageTitle title="Asset List" />}
      <Grid container spacing={4}>
      <Grid item xs={12}>
        {((customerId !== null && customerId !== undefined && customerId > 0) ? (sites !== undefined && sites != null && sites.length > 0) : true) &&
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={data !== undefined && data !== null ?
                  data.map(item => {
                return customerId === null || customerId === undefined || customerId <= 0 ?
                   [item.id,
                    item.code,
                    item.expires,
                    item.description,
                    item.make,
                    item.model,
                    item.asset_type,
                    item.customer_name,
                    item.site_name,
                    item.passed ? 'YES' : 'NO',
                    item.disposed ? 'YES' : 'NO'
                   ] :
                   [item.id,
                    item.code,
                    item.expires,
                    item.description,
                    item.make,
                    item.model,
                    item.asset_type,
                    item.site_name,
                    item.passed ? 'YES' : 'NO',
                    item.disposed ? 'YES' : 'NO'
                  ]
            }) : []}
            columns={customerId === null || customerId === undefined || customerId <= 0 ? columns : customerColumns}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filterType: "multiselect",
              serverSide: true,
              searchOpen: true,
              print: false,
              viewColumns: false,
              download: false,
              selectableRows: 'none',
              rowsPerPageOptions: [10,15,20,50,100],
              onSearchChange: searchText => delayedOnSearchKey(searchText),
              onRowClick: row => {
                if (customerId === undefined || customerId === null || customerId <= 0) {
                  history.push({pathname:`/app/asset/edit/${row[0]}`,
                                           state:{assetId: row[0]}
                                         });
                }
                else {
                  window.open(
                          `${config.adminApi}/#/app/asset/edit/${row[0]}`,
                          '_blank'
                        );
                }
              },
              count: count,
              page: page,
              textLabels: { body: { noMatch : isLoading ? <CircularProgress size={25} color={'inherit'} /> : `${isAllAssetsListWithAnySearchingCriteria() || (customerId !== undefined && customerId !== null && customerId > 0) ? 'Sorry, no matching records found.' : 'There are too many assets to display them all, try search asset code or use the filters.'}` }, },
              rowsPerPage: rowsPerPage,
              onChangePage:(currentPage) => {
                setPage(currentPage);
              },
              onChangeRowsPerPage: (numberOfRows) => {
                setRowsPerPage(numberOfRows);
              },
              onTableChange: (action, tableState) => {
                //console.log(action);
                //console.log( tableState);
                switch (action) {
                  case "changePage":
                    changePage(tableState.page, tableState.rowsPerPage);
                    break;
                  case "changeRowsPerPage":
                    changePage(tableState.page, tableState.rowsPerPage);
                    break;
                }
              },
              onTableInit: (action, tableState) => {//console.log('onTableInit')
                 updateFilterOnTableInitOrChange(tableState);
              },
              onFilterChange: (columnChanged, filterList) => {//console.log('onFilterChange',columnChanged, filterList )
                  setupFromAndToForFilter(filterList[2]);

                  setSelectedTypes(filterList[6]);
                  setSelectedPassed((customerId !== undefined && customerId !== null && customerId > 0) ? filterList[8] : filterList[9]);
                  setSelectedDisposed((customerId !== undefined && customerId !== null && customerId > 0) ? filterList[9] : filterList[10]);
                  if (customerId !== undefined && customerId !== null && customerId > 0) {
                    var filteredSites = sites.filter(site => filterList[7].find(selectedSiteName => selectedSiteName === site.name))
                                        .map(function(site) {
                                              return site.id;
                                            });;
                    //console.log('onFilterChange', filteredSites );
                    setSelectedSites(filteredSites);
                  }


               },
               onColumnSortChange: (changedColumn, direction) => {
                    setSortByColumn(changedColumn);
                    setSortDirection(direction);
               },
               customRowRender: (data, dataIndex, rowIndex) => {
                      return  (
                         <TableRow key={data[0]} id={rowIndex}
                                   style={{textDecoration: ((customerId !== undefined && customerId !== null && customerId > 0) ? data[9] : data[10]) === 'YES' ? 'line-through' : 'none'}}
                                   className={classes.tableRow}
                                   onClick={() => onRowClick(data,rowIndex)}>
                             <TableCell >
                                 <div>{data[1]}</div>
                             </TableCell>
                             <TableCell >
                                  <div className={new Date(data[2]) < new Date() ? classes.expired : ''}>{data[2]}</div>
                             </TableCell>
                             <TableCell >
                                   <div>{data[6]}</div>
                                   <div>{data[3]}</div>
                             </TableCell>
                             <TableCell >
                                   <div>{data[4]}</div>
                                   <div>{data[5]}</div>
                             </TableCell>
                             {(customerId === undefined || customerId === null || customerId <= 0) && <TableCell >
                               <div>{data[7]}</div>
                             </TableCell>}
                             <TableCell >
                                    <div>{(customerId !== undefined && customerId !== null && customerId > 0) ? data[7] : data[8]}</div>
                              </TableCell>
                             <TableCell style={{color: ((customerId !== undefined && customerId !== null && customerId > 0) ? data[8] : data[9]) === 'YES' ? '#3CD4A0' : '#f44336'}}>
                                    <div>{(customerId !== undefined && customerId !== null && customerId > 0) ? data[8] : data[9]}</div>
                              </TableCell>
                         </TableRow>
                       );
               }
            }}
          />
        </MuiThemeProvider>}
      </Grid>
      </Grid>
    </>
  );
});

export default Assets;
